import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__container">
          <h1 className="cart-page__title">Your Cart</h1>
          <div className="cart-page__empty">
            <p>Your cart is empty</p>
            <Link onClick={toTop} to="/shop" className="cart-page__continue-shopping">
              CONTINUE BROWSING
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <h1 className="cart-page__title">Your Cart</h1>

        <Link onClick={toTop} to="/shop" className="cart-page__continue-link">
          ← CONTINUE BROWSING
        </Link>

        <div className="cart-page__header">
          <div className="cart-page__header-product"></div>
          <div className="cart-page__header-price">PRICE</div>
          <div className="cart-page__header-quantity">QUANTITY</div>
          <div className="cart-page__header-total">TOTAL</div>
        </div>

        <div className="cart-page__items">
          {cartItems.map((item) => {
            const product = getProductById(item.id);
            if (!product) return null;

            const itemTotal =
              parseFloat(product.price.replace(/,/g, "")) * item.quantity;

            return (
              <div key={`${item.id}-${item.size}-${item.color}`} className="cart-page__item">
                <div className="cart-page__item-product">
                  <div className="cart-page__item-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-page__item-info">
                    <h3 className="cart-page__item-name">{product.name}</h3>
                    {item.size && <p className="cart-page__item-detail">Size: {item.size}</p>}
                    {item.color && <p className="cart-page__item-detail">Color: {item.color}</p>}
                    <button
                      className="cart-page__item-remove"
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      REMOVE
                    </button>
                  </div>
                </div>

                <div className="cart-page__item-price">
                  <p>${product.price}</p>
                </div>

                <div className="cart-page__item-quantity">
                  <div className="cart-page__quantity-controls">
                    <button
                      className="cart-page__quantity-btn"
                      onClick={() =>
                        handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)
                      }
                    >
                      −
                    </button>
                    <span className="cart-page__quantity-value">{item.quantity}</span>
                    <button
                      className="cart-page__quantity-btn"
                      onClick={() =>
                        handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)
                      }
                    >
                      +
                    </button>
                  </div>
                </div>

                <div className="cart-page__item-total">
                  <p>${itemTotal.toFixed(2)}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-page__footer">
          <div className="cart-page__subtotal">
            <p>SUBTOTAL</p>
            <p className="cart-page__subtotal-price">${subtotal.toFixed(2)} USD</p>
          </div>
          <p className="cart-page__shipping-note">
            Shipping & taxes calculated at checkout
          </p>
          <button className="cart-page__checkout" onClick={handleCheckout}>
            CHECK OUT
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
